import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import API from 'api';
import { API_STATUS } from 'constants/constants';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useRef } from 'react';
import { Spin } from 'antd';

const Verify = ({ type }) => {
  const [status, setStatus] = useState(API_STATUS.IDLE);
  const location = useLocation();
  const [second, setSecond] = useState(5);
  const refInterval = useRef();
  const navigate = useNavigate();

  const verifyEmail = async () => {
    const url = new URLSearchParams(location.search);
    const token = url.get('token');
    const email = url.get('email');

    if (!email || !token) {
      return setStatus(API_STATUS.ERROR);
    }

    setStatus(API_STATUS.PROCESSING);
    const res = await API.verifyRegisterEmail({ verifyToken: token, email });
    if (res.status === 200) {
      decreTime();
      return setStatus(API_STATUS.SUCCESS);
    }

    setStatus(API_STATUS.ERROR);
  };

  const decreTime = () => {
    refInterval.current = setInterval(() => {
      setSecond((s) => (s > 0 ? s - 1 : s));
    }, 1000);
  };

  useEffect(() => {
    if (second === 0) {
      navigate('/auth/login');
    }// eslint-disable-next-line
  }, [second]);

  useEffect(() => {
    if (type === 'register' && status !== API_STATUS.PROCESSING) {
      verifyEmail();
    }
    return () => {
      if (refInterval.current) clearInterval(refInterval.current);
    };
    // eslint-disable-next-line
  }, []);

  return type === 'register' ? (
    <div className="verify-register-container">
      {status === API_STATUS.SUCCESS && (
        <>
          <div className="icon-status success">
            <CheckOutlined />
          </div>
          <div className="text-success">Verification Success</div>
          <p>
            Your account has been verified. You will be automatically redirected
            to Login Page
          </p>
          <Spin size='medium' className='spin-global' />
          <p>You will be redirected in {second} secs.</p>
        </>
      )}
      {status === API_STATUS.ERROR && (
        <>
          <div className="icon-status error">
            <CloseOutlined />
          </div>
          <div className="text-error">Verification Failed</div>
          <p>Please contact admin support.</p>
        </>
      )}

      <div>
        {status === API_STATUS.PROCESSING && (
          <Spin size='medium' className='spin-global' />
        )}
      </div>
    </div>
  ) : null;
};

export default Verify;
